import React, { Component } from 'react';

import $dataRepo from 'dataRepository';

import './LicensePage.css';

class LicensePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      innerHTML: ''
    };
  }

  componentDidMount() {
    // load html
    $dataRepo.fetchLicenseText().then(html => this.setState({
      innerHTML: html
    }));
  }

  render() {
    const { innerHTML } = this.state;
    return (
      <div className="license-content-block header-border">
        <div
          dangerouslySetInnerHTML={{ __html: innerHTML }}
        />
      </div>
    );
  }
}

export default LicensePage;
